<template>
  <div class="p-grid" @click.stop="">
    <div class="p-col-12">
      <Dialog
        :header="$t('operacion.detalleOperacion.dialogCancelarOperacion')"
        :modal="true"
        :visible.sync="displaydialogCancelarOperacion"
        :contentStyle="{ overflow: 'visible' }"
      >
        <p>
          {{ $t("operacion.detalleOperacion.mensajeDialogCancelarOperacion") }}
        </p>
        <Errors
          v-show="this.errorsFieldsCancel.length > 0"
          :errors="this.errorsFieldsCancel"
        />
        <Dropdown
          v-model="selectedMotivoCancelacion"
          :options="this.dropdownMotivoCancelacion"
          optionLabel="name"
          :placeholder="$t('operacion.detalleOperacion.dialogSelectCancel')"
          :filter="false"
          @change="changeSelectedCancelacion"
        />
        <template #footer>
          <Button
            :label="$t('common.buttons.confirm')"
            icon="pi pi-check"
            @click="cancelOperation()"
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closeCancelOperation"
          />
        </template>
      </Dialog>
      <Dialog
        :header="$t('operacion.detalleOperacion.dialogSuspenderOperacion')"
        :modal="true"
        :visible.sync="displaydialogSuspenderOperacion"
        :contentStyle="{ overflow: 'visible' }"
      >
        <p>
          {{ $t("operacion.detalleOperacion.mensajeDialogSuspenderOperacion") }}
        </p>
        <Errors
          v-show="this.errorsFieldsSuspension.length > 0"
          :errors="this.errorsFieldsSuspension"
        />
        <div class="p-field p-col-12 p-md-4">
          <Dropdown
            v-model="selectedMotivoSuspension"
            :options="this.dropdownMotivoSuspension"
            optionLabel="name"
            :placeholder="
              $t('operacion.detalleOperacion.dialogSelectSuspension')
            "
            :filter="false"
            @change="changeSelectedSuspension"
          />
        </div>
        <div class="p-field">
          <label for="basic">{{
            $t("operacion.detalleOperacion.fechaLimiteSuspension")
          }}</label>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <Calendar
            id="icon"
            v-model="suspensionDate"
            :minDate="minSuspensionDate"
            dateFormat="dd/mm/yy"
            :showIcon="true"
            :showTime="true"
            :locale="getLocale"
          />
        </div>
        <template #footer>
          <Button
            :label="$t('common.buttons.confirm')"
            icon="pi pi-check"
            @click="suspendOperation()"
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closeSuspendOperation"
          />
        </template>
      </Dialog>
      <Dialog
        :header="$t('operacion.detalleOperacion.dialogRecuperarOperacion')"
        :modal="true"
        :visible.sync="displaydialogRecuperarOperacion"
      >
        <div class="messageRecoverOperation">
          <b
            ><p>
              {{ $t("operacion.detalleOperacion.mensajeAvisoRecuperado") }}
            </p>
            <p>
              {{ $t("operacion.detalleOperacion.mensajeAvisoRecuperado2") }}
            </p></b
          >
        </div>
        <p>
          {{ $t("operacion.detalleOperacion.mensajeDialogRecuperarOperacion") }}
        </p>
        <template #footer>
          <Button
            :label="$t('common.buttons.confirm')"
            icon="pi pi-check"
            @click="recoverOperation()"
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closeRecoverOperation"
          />
        </template>
      </Dialog>
      <Dialog
        :header="$t('operacion.detalleOperacion.dialogPagoParcialOperacion')"
        :modal="true"
        :visible.sync="displaydialogPagoParcialOperacion"
        :contentStyle="{ overflow: 'visible' }"
      >
        <p>
          {{
            $t("operacion.detalleOperacion.mensajeDialogPagoParcialOperacion")
          }}
        </p>
        <Errors
          v-show="this.errorsFieldsPagoParcial.length > 0"
          :errors="this.errorsFieldsPagoParcial"
        />
        <InputText type="text" v-model="qty" />
        <template #footer>
          <Button
            :label="$t('common.buttons.confirm')"
            icon="pi pi-check"
            @click="pagoParcialOperacion()"
          />
          <Button
            :label="$t('common.buttons.cancel')"
            icon="pi pi-times"
            class="p-button-secondary"
            @click="closePagoParcial"
          />
        </template>
      </Dialog>
      <p>
        <span
          :class="
            esBotoneraPequenia
              ? 'status-badge-listado-botonera-pequenia'
              : 'status-badget-listado'
          "
          v-for="accion in listadoAcciones"
          v-bind:key="accion.key"
        >
          <Button
            :label="obtenerLabel(accion.title)"
            :icon="accion.icon"
            iconPos="left"
            :class="accion.classButton"
            @click="openDialog(accion.key)"
            v-tooltip.bottom="accion.tooltip"
          />
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import StringsMixin from "@/utils/strings";
import AbilitiesMixin from "@/utils/ability";
import Errors from "@/components/utilidades/Errors.vue";
import Operacion from "@/resources/operacion";
import {
  BOTONERA_ACCIONES_CANCELAR_OPERACION,
  BOTONERA_ACCIONES_SUSPENDER_OPERACION,
  BOTONERA_ACCIONES_RECUPERAR_OPERACION,
  BOTONERA_ACCIONES_PAGO_PARCIAL_OPERACION,
  BOTONERA_ACCIONES_LISTADOS_OPERACION,
} from "@/graphQLQueries/OtrosQueries";

export default {
  name: "BotoneraAccionesOperacion",
  mixins: [StringsMixin, AbilitiesMixin],
  components: {
    Errors: Errors,
  },
  data() {
    return {
      todasAcciones: [],
      accionPagoParcial: {},
      displaydialogCancelarOperacion: false,
      displaydialogSuspenderOperacion: false,
      displaydialogRecuperarOperacion: false,
      displaydialogPagoParcialOperacion: false,
      dropdownMotivoCancelacion: [],
      dropdownMotivoSuspension: [],
      selectedMotivoCancelacion: {},
      selectedMotivoSuspension: {},
      suspensionDate: null,
      previousMonthToday: null,
      minSuspensionDate: null,
      errorsFieldsCancel: [],
      errorsFieldsSuspension: [],
      errorsFieldsRecover: [],
      errorsFieldsPagoParcial: [],
      qty: 0,
    };
  },
  props: [
    "accionesPosibles",
    "uuidOperacion",
    "totalPendiente",
    "divisa",
    "tramitadorUuid",
    "esBotoneraPequenia",
  ],
  created() {
    let today = new Date();
    let todayPrevious = new Date();
    let month = today.getMonth();
    let prevMonth = month === 0 ? 11 : month - 1;
    todayPrevious.setMonth(prevMonth);
    this.minSuspensionDate = today;
    this.suspensionDate = today;
    this.previousMonthToday = todayPrevious;
    this.todasAcciones = [
      {
        title: this.$i18n.t("operacion.detalleOperacion.botonera.RECUPERADA"),
        classButton: "p-button-success botonera",
        icon: "pi pi-thumbs-up",
        key: "RECUPERADA",
        hasPermissions: true,
        tooltip: this.$i18n.t("operacion.detalleOperacion.botonera.RECUPERADA"),
      },
      {
        title: this.$i18n.t(
          "operacion.detalleOperacion.botonera.PAGO_PARCIAL_OPERACION"
        ),
        classButton: "p-button-secondary botonera",
        icon: "pi pi-dollar",
        key: "PAGO_PARCIAL_OPERACION",
        hasPermissions: this.totalPendiente > 0,
        tooltip: this.$i18n.t(
          "operacion.detalleOperacion.botonera.PAGO_PARCIAL_OPERACION"
        ),
      },
      {
        title: this.$i18n.t("operacion.detalleOperacion.botonera.SUSPENDIDA"),
        classButton: "p-button-warning botonera",
        icon: "pi pi-calendar-times",
        key: "SUSPENDIDA",
        hasPermissions: true,
        tooltip: this.$i18n.t("operacion.detalleOperacion.botonera.SUSPENDIDA"),
      },
      {
        title: this.$i18n.t("operacion.detalleOperacion.botonera.CANCELADA"),
        classButton: "p-button-danger botonera",
        icon: "pi pi-times",
        key: "CANCELADA",
        hasPermissions: true,
        tooltip: this.$i18n.t("operacion.detalleOperacion.botonera.CANCELADA"),
      },
    ];
  },
  computed: {
    listadoAcciones() {
      var result = this.todasAcciones.filter(
        (accion) => this.accionesPosibles[accion.key] && accion.hasPermissions
      );
      return result;
    },
    getLocale() {
      return this.$i18n.t("calendar");
    },
  },
  apollo: {
    listadosDropdowns: {
      query: BOTONERA_ACCIONES_LISTADOS_OPERACION,
      variables() {
        return {
          idioma: this.$i18n.locale,
        };
      },
      update(data) {
        const dropdownCancelacion = data.listadoMotivosCancelacionOperacion.map(
          (motivo) => {
            return {
              name: motivo.valor,
              code: motivo.clave,
            };
          }
        );

        const recoveredDebtElementIdx = dropdownCancelacion.findIndex(
          (e) => e.code == "recovered_debt"
        );
        dropdownCancelacion.splice(
          0,
          0,
          ...dropdownCancelacion.splice(recoveredDebtElementIdx, 1)
        );

        const otherElementIdx = dropdownCancelacion.findIndex(
          (e) => e.code == "other"
        );
        dropdownCancelacion.push(
          dropdownCancelacion.splice(otherElementIdx, 1)[0]
        );

        const dropdownSuspension = data.listadoMotivosSuspension.map(
          (motivo) => {
            return {
              name: motivo.valor,
              code: motivo.clave,
            };
          }
        );
        this.dropdownMotivoCancelacion = dropdownCancelacion;
        this.dropdownMotivoSuspension = dropdownSuspension;
      },
    },
  },
  methods: {
    obtenerLabel(label) {
      return this.esBotoneraPequenia ? "" : label;
    },
    tienePermisos(role) {
      const agentIsPresent =
        this.tramitadorUuid != null && this.tramitadorUuid != undefined;
      const operacion = new Operacion({ hasAgent: agentIsPresent });
      const hasPermissions = this.checkAbilityWithEntity(role, operacion);
      return hasPermissions;
    },
    closeCancelOperation() {
      this.displaydialogCancelarOperacion = false;
      this.errorsFieldsCancel = [];
    },
    closeSuspendOperation() {
      this.displaydialogSuspenderOperacion = false;
      this.errorsFieldsSuspension = [];
    },
    closeRecoverOperation() {
      this.displaydialogRecuperarOperacion = false;
      this.errorsFieldsRecover = [];
    },
    closePagoParcial() {
      this.displaydialogPagoParcialOperacion = false;
      this.errorsFieldsPagoParcial = [];
    },
    changeSelectedCancelacion(event) {
      this.selectedMotivoCancelacion = event.value;
    },
    changeSelectedSuspension(event) {
      this.selectedMotivoSuspension = event.value;
    },
    cancelOperation() {
      if (this.selectedMotivoCancelacion.code == "recovered_debt") {
        this.recoverOperation();
        return;
      }

      this.$apollo
        .mutate({
          mutation: BOTONERA_ACCIONES_CANCELAR_OPERACION,
          variables: {
            motivoCancelacion: this.selectedMotivoCancelacion.code || "",
            uuidOperacion: this.uuidOperacion,
            usuarioUuid: this.$store.state.profile.uuid,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.errorsFieldsCancel = [];
          this.displaydialogCancelarOperacion = false;
          this.processAction("CANCELADA");
        })
        .catch((exception) => {
          this.errorsFieldsCancel = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorsFieldsCancel.push(
              this.$i18n.t("acciones.errores." + error.message)
            );
          });
        });
    },
    suspendOperation() {
      this.$apollo
        .mutate({
          mutation: BOTONERA_ACCIONES_SUSPENDER_OPERACION,
          variables: {
            fechaLimite:
              this.suspensionDate != null
                ? this.suspensionDate.getTime()
                : this.previousMonthToday.getTime(),
            motivoSuspension: this.selectedMotivoSuspension.code || "",
            uuidOperacion: this.uuidOperacion,
            usuarioUuid: this.$store.state.profile.uuid,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.errorsFieldsSuspension = [];
          this.displaydialogSuspenderOperacion = false;
          this.processAction("SUSPENDIDA");
        })
        .catch((exception) => {
          this.errorsFieldsSuspension = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorsFieldsSuspension.push(
              this.$i18n.t("acciones.errores." + error.message)
            );
          });
        });
    },
    recoverOperation() {
      this.$apollo
        .mutate({
          mutation: BOTONERA_ACCIONES_RECUPERAR_OPERACION,
          variables: {
            uuidOperacion: this.uuidOperacion,
            recuperadoAutomatico: true,
            usuarioUuid: this.$store.state.profile.uuid,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.errorsFieldsRecover = [];
          this.displaydialogRecuperarOperacion = false;
          this.displaydialogCancelarOperacion = false;
          this.processAction("RECUPERADA");
        })
        .catch((exception) => {
          this.errorsFieldsValidate = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorsFieldsValidate.push(
              this.$i18n.t("acciones.errores." + error.message)
            );
          });
        });
    },
    pagoParcialOperacion() {
      this.$apollo
        .mutate({
          mutation: BOTONERA_ACCIONES_PAGO_PARCIAL_OPERACION,
          variables: {
            uuidOperacion: this.uuidOperacion,
            importe: this.qty,
            divisa: this.divisa,
            usuarioUuid: this.$store.state.profile.uuid,
          },
          update(data) {
            return data;
          },
        })
        .then(() => {
          this.errorsFieldsPagoParcial = [];
          this.displaydialogPagoParcialOperacion = false;
          this.processAction("PAGO_PARCIAL_OPERACION");
        })
        .catch((exception) => {
          this.errorsFieldsPagoParcial = [];
          exception.graphQLErrors.forEach((error) => {
            this.errorsFieldsPagoParcial.push(
              this.$i18n.t("acciones.errores." + error.message)
            );
          });
        });
    },
    openDialog(type) {
      switch (type) {
        case "CANCELADA":
          this.displaydialogCancelarOperacion = true;
          break;
        case "SUSPENDIDA":
          this.displaydialogSuspenderOperacion = true;
          break;
        case "RECUPERADA":
          this.displaydialogRecuperarOperacion = true;
          break;
        case "PAGO_PARCIAL_OPERACION":
          this.displaydialogPagoParcialOperacion = true;
          break;
        default:
          break;
      }
    },
    processAction(action) {
      this.$emit("clickedAction", action);
    },
  },
};
</script>
<style lang="scss" scoped>
.p-button {
  margin-right: 0.5rem;
}
.botonera {
  margin-bottom: 4px;
}
.status-badget-listado:nth-child(2) {
  margin-left: -7px;
}
</style>